'use client';

import { __rest, __assign } from '../../_virtual/_tslib.js';
import React__default from 'react';
import Typography from '../index.js';
import { AnchorCss } from './styled.css.js';

var H1 = React__default.forwardRef(function (_a, ref) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React__default.createElement(Typography, __assign({ ref: ref, variant: 'h1' }, rest), children));
});
var H2 = React__default.forwardRef(function (_a, ref) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React__default.createElement(Typography, __assign({ ref: ref, variant: 'h2' }, rest), children));
});
var H3 = React__default.forwardRef(function (_a, ref) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React__default.createElement(Typography, __assign({ ref: ref, variant: 'h3' }, rest), children));
});
var H4 = React__default.forwardRef(function (_a, ref) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React__default.createElement(Typography, __assign({ ref: ref, variant: 'h4' }, rest), children));
});
var H5 = React__default.forwardRef(function (_a, ref) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React__default.createElement(Typography, __assign({ ref: ref, variant: 'h5' }, rest), children));
});
var H6 = React__default.forwardRef(function (_a, ref) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React__default.createElement(Typography, __assign({ ref: ref, variant: 'h6' }, rest), children));
});
var Label = React__default.forwardRef(function (_a, ref) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React__default.createElement(Typography, __assign({ ref: ref, variant: 'label' }, rest), children));
});
var Paragraph = React__default.forwardRef(function (_a, ref) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React__default.createElement(Typography, __assign({ ref: ref, variant: 'p' }, rest), children));
});
var Span = React__default.forwardRef(function (_a, ref) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React__default.createElement(Typography, __assign({ ref: ref, variant: 'span' }, rest), children));
});
var Anchor = React__default.forwardRef(function (_a, ref) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React__default.createElement(AnchorCss, __assign({ ref: ref, variant: 'a' }, rest), children));
});

export { Anchor, H1, H2, H3, H4, H5, H6, Label, Paragraph, Span };
//# sourceMappingURL=Variant.js.map
